export default __webpack_public_path__ + "static/media/GU.131e5a11.svg";